import "./App.css";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/scss/bootstrap.scss";
import "bootstrap-icons/font/bootstrap-icons.scss";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import {
  MaxPayoutFormularView,
  NotFoundView,
  RoundHistoryView,
  RuleView,
  SettingView,
} from "./views";
import { TranslationProvider } from "./context/TranslationContext";
function App() {
  return (
    <TranslationProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/:gameCode/rules" element={<RuleView />} />
          <Route path="/:gameCode/settings" element={<SettingView />} />
          <Route path="/:type/:id" element={<RoundHistoryView />} />
          <Route path="/combined" element={<MaxPayoutFormularView />} />
          <Route path="*" element={<NotFoundView />} />
        </Routes>
      </BrowserRouter>
    </TranslationProvider>
  );
}

export default App;
